import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    offers: [],
    totalOffer: 0,
  },
  mutations: {
    updateField,
    SET_STOCK_OFFER(state, payload) {
      state.offers = payload.ofertas ? payload.ofertas.my_stock : [];
      state.totalOffer = payload.total;
    },
  },
  actions: {
    async getStockOffer({ commit }, obj) {
      const { data } = await axios.get(`${url}/oferta`, {
        params: {
          // page: obj.page,
          // limit: obj.limit,
          filter: obj.filter ? obj.filter : null,
          segmentos: obj.segmentos,
        },
      });
      commit('SET_STOCK_OFFER', data);
    },
    // eslint-disable-next-line no-unused-vars
    async getContactOffer({ commit }, stockId) {
      const { data } = await axios.get(`${url}/info-contato/${stockId}`, {});
      return data;
    },
  },
  getters: { getField },
};
